import { useTranslation } from "react-i18next";

import { useChat } from "../context/use-chat";

import { MayaOrb } from "./maya-orb";

/** Maya's row while a reply is being written: the orb spun up plus the AI's
 *  live step ("Checking payroll runs…") as shimmering text.
 *
 *  It sits inside the message list's `role="log"`, which announces it once
 *  when it appears ("Maya is typing"). The step text is hidden from assistive
 *  tech — it changes every second or two and would be read out each time. */
export const TypingIndicator = () => {
  const { t } = useTranslation(["common"]);
  const { status } = useChat();
  return (
    <div className="animate-rise-in flex items-center gap-2.5">
      <span className="sr-only">{t("common:a11y.maya_is_typing")}</span>
      <MayaOrb size={24} thinking />
      <span
        aria-hidden="true"
        className="maya-shimmer-text min-w-0 truncate text-xs font-medium"
      >
        {status ?? t("common:maya.thinking")}
      </span>
    </div>
  );
};
